import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTeaAndCoffee32 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 29,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 23v1H.5v-1h28Zm-6-23a1 1 0 0 1 .869 1.495L23.3 1.6 21.5 4v17h-14l-.001-3H5.5v-1h1.999v-1H4.833a1.334 1.334 0 0 1-1.327-1.205l-.006-.128V4.333c0-.693.529-1.262 1.205-1.327L4.833 3H7.5L7.5 0h15Zm-.002 1H8.5v19h12V3.667L22.498 1ZM7.499 4H4.833a.333.333 0 0 0-.326.266l-.007.067v10.334c0 .16.114.295.266.326l.067.007H7.5V4Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgTeaAndCoffee32;